/**
 * Liste des capacités (actions/affichages gatés par le rôle actif).
 * Qui a droit à quoi → `capabilityMatrix.ts`. Gate UI → `useRoleCan(Capability.X)`.
 */
export const Capability = {
  // Liste Simulations
  SimulationOpen: 'simulation.open', // clic ligne (ouverture du process)
  SimulationActions: 'simulation.actions', // colonne d'actions

  // Liste Devis
  QuoteOpen: 'quote.open',
  QuoteActions: 'quote.actions',

  // Liste Leads
  LeadAssign: 'lead.assign', // attribuer (ligne, groupé, panneau détail)

  // Fiche client
  ClientDetailActions: 'client.detail.actions', // actions rapides (mail, note…)

  // Liste Contrats
  ContractOpen: 'contract.open', // clic ligne (détail)
  ContractViewActions: 'contract.actions.view', // œil (consultation)
  ContractWriteActions: 'contract.actions.write', // menu, créer, suppression groupée
  ContractDetailActions: 'contract.detail.actions', // onglets « actions » du détail

  // Contrats de groupe
  GroupContractActions: 'group-contract.actions', // actions de la liste
  GroupContractBrokerMode: 'group-contract.broker-mode', // variante courtier des écrans
  GroupContractManageBrokers: 'group-contract.manage-brokers', // sélection courtiers (admin)

  // Flux d'activité / notifications
  ActivityFeedLinks: 'activity-feed.links', // liens cliquables vers les entités
  ListNotificationBadges: 'lists.notification-badges', // pastilles/marqueurs non-lus (listes, détail contrat, « nouveau » timeline)

  // Notes
  NotesAccess: 'notes.access', // bouton + page + onglets notes

  // Tunnel de souscription (routes /simulation/*)
  SubscriptionProcessAccess: 'process.access',

  // Bouton « Créer » global
  CreateMenuAccess: 'create-menu.access',

  // Listes du portefeuille de la plateforme (compagnie SANS profil courtier,
  // rôle actif Plateforme) : contrats, devis, simulations, clients — le
  // serveur borne en vue plateforme (portefeuille partagé de l'OU).
  PlateformePortfolioLists: 'plateforme.portfolio-lists',

  // Habilitations tunnels (matrice courtiers × tunnels) : entrée de menu
  // /mes-habilitations-tunnels + sa route. La règle « brique Conception
  // d'offre requise » vit dans la matrice, consommée par menuPolicy ET
  // routePolicy (une seule source, pas deux copies).
  TunnelHabilitationsAccess: 'tunnel-habilitations.access',

  // Validations de devis (Portail Gestion) : entrée de menu /validations + sa
  // route. Portée par la brique Valideur uniquement.
  ValidationsAccess: 'validations.access',

  // Barre de recherche globale de l'en-tête (clients, contrats, devis…).
  GlobalSearchAccess: 'global-search.access',

  // Statistiques du portefeuille sur /bord (tuiles, graphiques, sélecteur de
  // période). Le bandeau de bienvenue et le flux d'activité restent visibles.
  PortfolioOverview: 'dashboard.portfolio-overview'
} as const;

export type Capability = (typeof Capability)[keyof typeof Capability];
